//React
import React, { useEffect, useState } from "react";

//Axios
import axios from "axios";

//Material Ui Components ,Styles and Icons
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import {
  Grid,
  CircularProgress,
  Checkbox,
  InputAdornment,
  Link,
  TextField,
  IconButton,
  OutlinedInput,
  FormControl,
  FormControlLabel,
} from "@material-ui/core";

//Global Assets
import GlobalApi from "../../Global";
import Colors from "../../Global/colors";
import DarkButton from "../../Global/DarkButton";
import email from "../../Assets/email.png";
import password from "../../Assets/Password.png";
import refresh_token from "../../Global/refresh_token";

//React Router
import { Redirect } from "react-router";
import { useHistory } from "react-router-dom";

//Custom Components and Styles
import swal from "@sweetalert/with-react";

//Redux
import { useDispatch,useSelector } from "react-redux";
import { addUser } from "../../Redux/Actions/userAction";
import { addTeam } from "../../Redux/Actions/teamAction";
import { addCompany } from "../../Redux/Actions/companyAction";
import { addCompanyArr } from "../../Redux/Actions/companyArrActions";
import { addIndustryArr } from "../../Redux/Actions/industryArrActions";
import { addIndustry } from "../../Redux/Actions/industryAction";
import { addAccordianState } from "../../Redux/Actions/accordianAction";
import { updateNotification } from "../../Redux/Actions/notificationAction";


//translate
import { useTranslation } from "react-i18next";


//CUSTOM THEME STYLES
const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(2),
      width: "60ch",
      Border: "0px",
    },
  },
  textField: {
    borderColor: Colors.globalColor4,
    backgroundColor: Colors.globalColor5,
    borderRadius: 5,
  },
  resize: {
    fontSize: 14,
  },
}));

//Main Function
export default function SigninForm({ location }) {
  let {t} = useTranslation();
  let language = useSelector((state) => state.languageReducer.language);
  let history = useHistory();
  const dispatch = useDispatch();
  const classes = useStyles();
  const [loginForm, setloginData] = useState({ email: "", password: "" });
  const [values, setValues] = useState({ showPassword: false });
  const [packageDetails, setPackageDetails] = useState(null);
  const [btnLoader, setBtnLoader] = useState(false);
  let [errorObj, setErrorObj] = useState({ email: "", password: "" });

  useEffect(() => {
    window.Intercom("update", {
      app_id: "g7aqg8ty",
      name: null,
      email: null,
    });
  }, []);




  //Get PAckage Details
  async function getPackageDetails() {
    
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let package_inquiry = {
      user_id: data.user_id,
      organization_id: data.organization_id,
    };

    let query = Object.keys(package_inquiry)
      .map(
        (k) =>
          encodeURIComponent(k) + "=" + encodeURIComponent(package_inquiry[k])
      )
      .join("&");
    let req = await fetch(
      GlobalApi + "/Package/get_user_license_details?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );

    let reqJson = await req.json();

  
    if (reqJson?.package?.license?.status === "expired" || reqJson?.package?.license?.status === "deactive") {
      history.replace("/billing");
    } else {
      setPackageDetails(reqJson.package);
      history.replace("/");
    }      
  }

  const getAccordianDetails = (userID,token) =>{
    let params = { user_id: userID };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/User/user_dashboard_accordion?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then(async (response) => {
        if(response.msg == "success"){
          console.log("RESPONSE OF GET ACCORDIAN DETAILS", response); 
          dispatch(addAccordianState(response.accordians));
        }else if (
            response.error === "jwt expired" ||
            response.error === "invalid token" ||
            response.error === "invalid signature" ||
            response.error === "jwt malformed" ||
            response.error === "Unexpected token"
          ) {
            let status = await refresh_token();
            // console.log(status);
            if (status) {
              // console.log("opopopop");
              getAccordianDetails();
            }
          }

        console.log("RESPONSE OF GET ACCORDIAN DETAILS", response);
      })
      .catch((error) => {
        console.log("Error", error);
      });
  }

  const getCompaniesArr = (token, organizationId) => {
    let params = { organization_id: organizationId };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    console.log("query", query);

    fetch(GlobalApi + "/company/companies?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((response) => {
        console.log("RESPONSE OF GET COMPANIES", response);
        dispatch(addCompanyArr(response.companies));
      })
      .catch((error) => {
        console.log("Error", error);
      });
  };

  function handleFormInputs(event) {
    let { name, value } = event.target;
    setloginData({ ...loginForm, [name]: value });
  }

  const getTeamData = (token, compnyID) => {
    let params = { company_id: compnyID };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/user/get_users?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if(response.msg == "success"){
          dispatch(addTeam(response));
          console.log("RESPONSE TEAM >>>>", response);
        }
        
      })
      .catch((error) => console.log(error.message));
  };

  async function getAllIndustries() {
    fetch(GlobalApi + "/get_all_industries")
      .then((response) => response.json())
      .then((json) => {
        // console.log('Industry Data >>>>', json)
        if (json.status === "Success") {
          console.log("Console of get all industrioes", json.data);

          dispatch(addIndustryArr(json.data));
        }
      })
      .catch((error) => {
        console.error("Industry Error ::", error);
      });
  }

  function handleSubmit(e) {
    e.preventDefault();
    let { email, password } = loginForm;
      let errors_obj = {};
    //if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email) === false) {
    if (
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        email
      ) === false
    ) {
      errors_obj.email = "Please Enter a Valid Email Format";
      setBtnLoader(false);
    }

    if (password.length === 0) {
      errors_obj.password = "Please Enter Your Password";
      setBtnLoader(false);
    }

    setErrorObj(errors_obj);
    if (Object.keys(errors_obj).length === 0) {
      axios
        .get(GlobalApi + "/login", { params: loginForm })
        .then(async (response) => {
          if (response.data.status ==  "Success") {
            console.log("RESPONSE DATA 1>>>>>>>>>>>>>>>",response.data)

              if (response.data.license.status !== "active") {
                if (response.data.super_admin === false) {
                  swal(t("Error"), t("your license has expired"), "error");
                  setBtnLoader(false);
                  return;
                }
              }
            
            let Obj = {
              ...response.data.data,
              super_admin: response.data.super_admin,
              industry_id: response.data.industry_id,
              company_id: response.data.companies[0].id,
              organization_id: response.data.organization_id,
              refresh_token: response.data.refreshToken,
              token: response.data.token,
              user_id: response.data.data.id,
              device_id: response.data.device_id,
              companies: response.data.companies,
            };
            if (response.data.super_admin) {
              getCompaniesArr(
                response.data.token,
                response.data.organization_id
              );
            }
            if (!response.data.super_admin) {
              dispatch(addCompanyArr(response.data.companies));
            }
            await getAllIndustries();
            await getTeamData(response.data.token,response.data.companies[0].id);
            console.log("DATA GOING IN REDUX FOR USER __________________",response.data.companies[0])
            
            console.log("1")
            await dispatch(addUser(Obj));
            await localStorage.setItem("UserData", JSON.stringify(Obj));
            console.log("2")
            dispatch(addIndustry(response.data.industry_id))
            console.log("3")
            dispatch(addCompany(response.data.companies[0]));
            console.log("4")
            dispatch(updateNotification(response.data.companies[0].id));
            console.log("5")
            setBtnLoader(false);
            await getAccordianDetails(response.data.data.id,response.data.token)

           
            await getPackageDetails();
            
            // if (!location) {
            //   history.replace("/template-editor/create");
            //   // window.location.reload()
            // } else {
            //   let param = getParams(window.location.href);
            //   console.log("params>>>>>>>>>>>>",param)
            //   history.replace(
            //     `${param.route}/${param.inspection}/${param.review}`
            //   );
            //   // window.location.reload()
            // }
          } else {
            console.log("here")
            swal(t("Warning"), response.data.error, "warning");
            setBtnLoader(false);
          }
        }).catch((error) => {
          if(error.response){
            swal(t("Warning"), error.response.data.error, "warning");
            console.log(error.response);
          }else{
            swal(t("Warning"), t("Internal Server Error"), "warning")
          }
          
          setBtnLoader(false);
        });
    }
  }

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  //Main Return
  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12}>
          <TextField
            fullWidth
            id="outlined-basic"
            name="email"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <img src={email} width={12} />
                </InputAdornment>
              ),
              classes: {
                input: classes.resize,
              },
            }}
            error={errorObj.email}
            helperText={errorObj.email}
            onChange={handleFormInputs}
            className={classes.textField}
            placeholder={t("Email Address")}
            variant="outlined"
            autoComplete={"off"}
            size="small"
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <FormControl
            // className={clsx(classes.margin, classes.textField)}
            className={classes.textField}
            variant="outlined"
            fullWidth
            size="small"
            InputProps={{
              classes: {
                input: classes.resize,
              },
            }}
          >
            <OutlinedInput
              error={errorObj.password}
              helperText={errorObj.password}
              fullWidth
              size="small"
              name="password"
              placeholder={t("Password")}
              className={(classes.textField, classes.resize)}
              id="outlined-adornment-password"
              type={values.showPassword ? "text" : "password"}
              value={values.password}
              onChange={handleFormInputs}
              startAdornment={
                <InputAdornment position="start">
                  <img src={password} width={10} />
                </InputAdornment>
              }
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    size="small"
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                    className="eyeIcon"
                  >
                    {values.showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
            />
            <span style={{ color: "red", fontSize: "12px", marginLeft: 15 }}>
              {errorObj.password}
            </span>
          </FormControl>
        </Grid>

        <Grid item align={language == "ar" ? "right" :"left"} xs={12} sm={6} style={{ paddingTop: 0 }}>
          <FormControlLabel
            className={"consentForm"}
            control={<Checkbox name="checkedB" color={Colors.globalColor8} />}
            label={t("Remember Me")}
            style={{ fontSize: 10 }}
          />
        </Grid>

        {window.innerWidth > 500 && 
        <Grid item align="right" xs={12} sm={6} style={{ paddingTop: 10 }}>
          <Link
            href="#"
            onClick={(e) => {
              e.preventDefault();
              history.push("/forgotpassword");
            }}
            style={{ color: Colors.globalColor8 }}
          >
            {t("Forgot Password?")}
          </Link>
        </Grid>}

        {window.innerWidth <= 500 && 
        <Grid item align="left" xs={12} sm={6} style={{ paddingTop: 10 }}>
          <Link
            href="#"
            onClick={(e) => {
              e.preventDefault();
              history.push("/forgotpassword");
            }}
            style={{ color: Colors.globalColor8 }}
          >
            {t("Forgot Password?")}
          </Link>
        </Grid>}



        <Grid item xs={12} sm={12} md={12}>

        {window.innerWidth > 500 &&
          <DarkButton
            size="medium"
            type="submit"
            onClick={(e) => {
              setBtnLoader(true);
              handleSubmit(e);
            }}
            style={{ backgroundColor: Colors.globalColor8 }}
          >
            {btnLoader == true && (
              <CircularProgress
                size={18}
                style={{ color: "white", marginRight: 7 }}
              />
            )}
            {t("Login")}
          </DarkButton>}

          {window.innerWidth <= 500 &&
          <DarkButton

            type="submit"
            onClick={(e) => {
              setBtnLoader(true);
              handleSubmit(e);
            }}
            style={{width:'100%', backgroundColor: Colors.globalColor8 }}
          >
            {btnLoader == true && (
              <CircularProgress
                size={18}
                style={{ color: "white", marginRight: 7 }}
              />
            )}
            {t("Login")}
          </DarkButton>}



        </Grid>
      </Grid>
    </form>
  );
}

//====================================== Unused Functions ============================//

// var getParams = function(url) {
//   var params = {};
//   var parser = document.createElement("a");
//   parser.href = url;
//   var query = parser.search.substring(1);
//   var vars = query.split("&");
//   for (var i = 0; i < vars.length; i++) {
//     var pair = vars[i].split("=");
//     params[pair[0]] = decodeURIComponent(pair[1]);
//   }
//   return params;
// };
